import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { TeamStatusEnum } from "../../../../../../commons/enums/team-status-enum";

interface ISubTeamActivateState {
  subTeamActivateStatus: StatusEnum;
}

const initialState: ISubTeamActivateState = {
  subTeamActivateStatus: StatusEnum.Idle,
};

export interface subTeamActiveOption {
  teamId: number;
  subTeamId: number;
}

export const subTeamActivate = createAsyncThunk(
  "manage/subTeamActive",
  async (options: subTeamActiveOption, thunkAPI) => {
    try {
      const subTeamActivateResponse = await manageFootballTeamService.changeSubTeamStatus(
        options.teamId,
        options.subTeamId,
        {
          status: Number(TeamStatusEnum.Active),
        }
      );
      return subTeamActivateResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const subTeamActivateSlice = createSlice({
  name: "subTeamActivate",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(subTeamActivate.pending, (state) => {
        state.subTeamActivateStatus = StatusEnum.Loading;
      })
      .addCase(subTeamActivate.fulfilled, (state, action) => {
        state.subTeamActivateStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamActivate.rejected, (state) => {
        state.subTeamActivateStatus = StatusEnum.Failed;
      });
  },
});

export default subTeamActivateSlice.reducer;
